import axiosClient from './utils/axiosClient';

export const CHAPTERS_VALIDATION_URI = 'chapters/validation';


export function getChapterValidationBySkillIdAndUserIdApi(skillId, userId) {
    return axiosClient.get(`${CHAPTERS_VALIDATION_URI}/skills/${skillId}/users/${userId}`);
}
